import { getOperation } from "utils/api";

export const queryList = async (params) => {
  return await getOperation("/payment/list", {
    sort: "created,desc",
    ...params,
  });
};

export const queryTagList = async () => {
  return await getOperation("/tag/sys");
};

export const exportCsv = async (params) => {
  return await getOperation("/payment/list", {
    output: "csv",
    ...params,
  });
};
